"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconActionChevronLeft = _interopRequireDefault(require("../Icons/IconActionChevronLeft"));

var _IconActionChevronRight = _interopRequireDefault(require("../Icons/IconActionChevronRight"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages,
      base = _ref.base,
      otherFilters = _ref.otherFilters,
      onClick = _ref.onClick,
      nextText = _ref.nextText,
      prevText = _ref.prevText,
      otherProps = _objectWithoutProperties(_ref, ["currentPage", "totalPages", "base", "otherFilters", "onClick", "nextText", "prevText"]);

  var urls = [];

  for (var index = 1; index <= totalPages; index++) {
    var generatedUrl = "".concat(base).concat(index);
    var pageNumber = index;

    if (base === undefined) {
      urls[index] = {
        url: "".concat(pageNumber),
        page: pageNumber
      };
    } else {
      urls[index] = {
        url: generatedUrl,
        page: pageNumber
      };
    }
  }

  var prevUrl = currentPage - 1;
  var nextUrl = currentPage + 1; // disable history pushing when you just want to update an querystring
  // If there is no base given (=undefined) then just provide a callback

  function handleOnclick(e) {
    if (base === undefined) {
      var _e$currentTarget, _e$currentTarget$getA, _e$currentTarget$getA2;

      e.preventDefault();
      var page = (e === null || e === void 0 ? void 0 : (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 ? void 0 : (_e$currentTarget$getA = _e$currentTarget.getAttribute('href')) === null || _e$currentTarget$getA === void 0 ? void 0 : (_e$currentTarget$getA2 = _e$currentTarget$getA.split('/')) === null || _e$currentTarget$getA2 === void 0 ? void 0 : _e$currentTarget$getA2.pop()) || [];
      onClick(page);
    }
  }

  return /*#__PURE__*/_react.default.createElement(PaginationWrapper, otherProps, currentPage > 1 ? /*#__PURE__*/_react.default.createElement(PaginationButton, {
    onClick: handleOnclick,
    to: urls[prevUrl].url
  }, /*#__PURE__*/_react.default.createElement(_IconActionChevronLeft.default, {
    color: "#C1C1C1"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, prevText)) : '', /*#__PURE__*/_react.default.createElement(PaginationPages, null, currentPage > 4 ? /*#__PURE__*/_react.default.createElement(PaginationPage, {
    onClick: handleOnclick,
    to: urls[1].url
  }, "1") : '', currentPage > 4 ? /*#__PURE__*/_react.default.createElement(PaginationPageNoLink, null, "...") : '', urls.map(function (url) {
    return url.page >= currentPage - 2 && url.page <= currentPage + 2 ? /*#__PURE__*/_react.default.createElement(PaginationPage, {
      to: url.url,
      key: url.page,
      active: url.page === currentPage ? 1 : 0,
      onClick: handleOnclick
    }, url.page) : '';
  }), currentPage < totalPages - 3 ? /*#__PURE__*/_react.default.createElement(PaginationPageNoLink, {
    disabled: true
  }, "...") : '', currentPage < totalPages - 3 ? /*#__PURE__*/_react.default.createElement(PaginationPage, {
    onClick: handleOnclick,
    to: urls[totalPages].url
  }, totalPages) : ''), currentPage < totalPages ? /*#__PURE__*/_react.default.createElement(PaginationButton, {
    onClick: handleOnclick,
    to: urls[nextUrl].url
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, nextText), /*#__PURE__*/_react.default.createElement(_IconActionChevronRight.default, {
    color: "#C1C1C1"
  })) : '');
};

var PaginationWrapper = _styledComponents.default.div.withConfig({
  displayName: "PaginationWrapper"
})(["display:flex;font-family:", ";justify-content:center;border:1px solid #e4e4e4;background-color:white;overflow:hidden;border-radius:5px;box-shadow:0 2px 7px rgba(0,0,0,0.1);"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var PaginationButton = (0, _styledComponents.default)(_reactRouterDom.Link).withConfig({
  displayName: "PaginationButton"
})(["display:flex;align-items:center;cursor:pointer;text-decoration:none;&:first-of-type{border-right:1px solid #e4e4e4;padding-right:10px;}&:last-of-type{border-left:1px solid #e4e4e4;padding-left:10px;}svg{transform:scale(0.5);}.label{font-size:1.4rem;line-height:120%;letter-spacing:0.04em;color:", ";transition:0.15s ease-in-out;}&:hover{.label{color:", ";}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.typo.interactive;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.brand.primary;
});

var PaginationPages = _styledComponents.default.div.withConfig({
  displayName: "PaginationPages"
})(["display:flex;justify-content:center;align-items:center;padding:8px 15px;"]);

var PaginationPage = (0, _styledComponents.default)(_reactRouterDom.Link).withConfig({
  displayName: "PaginationPage"
})(["cursor:", ";padding:4px 5px;margin:0 2px;background-color:", ";display:block;border-radius:5px;color:", ";font-size:1.4rem;line-height:120%;transition:color 0.15s ease-in-out;text-decoration:none;&:hover{color:", ";}"], function (_ref5) {
  var active = _ref5.active,
      disabled = _ref5.disabled;
  return active || disabled ? 'default' : 'pointer';
}, function (_ref6) {
  var active = _ref6.active,
      theme = _ref6.theme;
  return active ? theme.brand.primary : 'white';
}, function (_ref7) {
  var active = _ref7.active,
      theme = _ref7.theme;
  return active ? 'white' : theme.typo.interactive;
}, function (_ref8) {
  var theme = _ref8.theme,
      active = _ref8.active,
      disabled = _ref8.disabled;
  return active ? 'white' : disabled ? theme.typo.interactive : theme.brand.primary;
});

var PaginationPageNoLink = _styledComponents.default.div.withConfig({
  displayName: "PaginationPageNoLink"
})(["padding:4px 5px;margin:0 2px;background-color:", ";display:block;border-radius:5px;color:", ";font-size:1.4rem;line-height:120%;transition:color 0.15s ease-in-out;text-decoration:none;"], function (_ref9) {
  var active = _ref9.active,
      theme = _ref9.theme;
  return active ? theme.brand.primary : 'white';
}, function (_ref10) {
  var active = _ref10.active,
      theme = _ref10.theme;
  return active ? 'white' : theme.typo.interactive;
});

Pagination.defaultProps = {
  onClick: function onClick() {},
  prevText: 'Prev',
  nextText: 'Next'
};
Pagination.propTypes = {
  /** The current page the pagination component should show. */
  currentPage: _propTypes.number.isRequired,

  /** Total amount of pages possible. */
  totalPages: _propTypes.number.isRequired,

  /** Records shown per page. */
  pageLength: _propTypes.number.isRequired,

  /** URL on which the pagination is to be based. */
  base: _propTypes.string,

  /** Callback that fire's when there is no base */
  onClick: _propTypes.func,

  /** Text which has to be displayed on the previous button */
  prevText: _propTypes.string,

  /** Text which has to be displayed on the next button */
  nextText: _propTypes.string,

  /** Extra filters to be passed to the URL. */
  otherFilters: _propTypes.string
};
Pagination.defaultProps = {
  currentPage: 1,
  totalPages: 1,
  pageLength: 20
};
var _default = Pagination;
exports.default = _default;